module.exports = __webpack_public_path__ + "static/media/str-group-white.c517c0ca.svg";